import { Avatar, Text, UnstyledButton } from "@mantine/core";
import { IconChartBar } from "@tabler/icons-react";
import clsx from "clsx";

import classes from "../chat-components.module.css";
import avatarClasses from "./avatar-styles.module.css";
import { SelectedChatIndicator } from "./SelectedChatIndicator";

interface ExpertHubQueueButtonProps {
    /** True when the Expert Hub is currently shown (no chat selected) — drives the active highlight. */
    active: boolean;
    onClick: () => void;
}

/**
 * Queue entry (redesign v2 only) that returns the expert to the Expert Hub without closing a chat: it
 * deselects the active chat, so the off-call hub slides back in while the chats stay in the queue.
 * Reuses the chat-row interactive area + selected accent so it reads as part of the queue.
 */
export function ExpertHubQueueButton({ active, onClick }: ExpertHubQueueButtonProps) {
    return (
        <UnstyledButton
            id="chat-queue-expert-hub"
            className={clsx(classes.queued_chat_interactive_area, classes.queue_action_button)}
            onClick={onClick}
            data-selected={active}
            // Convey the active view to assistive tech, not just the visual accent (data-selected).
            aria-current={active ? "page" : undefined}
        >
            <SelectedChatIndicator isChatSelected={active} />
            {/* Matches the chat rows' 32px profile circle so the label lines up with the chat previews. */}
            <Avatar size={32} radius="xl" className={avatarClasses.chat_avatar} aria-hidden>
                <IconChartBar size={18} />
            </Avatar>
            <Text size="sm" fw="var(--mantine-font-weight-medium)">
                Home
            </Text>
        </UnstyledButton>
    );
}
